module.exports = __webpack_public_path__ + "img/03.a2bb4710.png";